/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Pickup_EmailInputs */

const en_inbound_field_pickup_email = /** @type {(inputs: Inbound_Field_Pickup_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup email`)
};

/**
* | output |
* | --- |
* | "Pickup email" |
*
* @param {Inbound_Field_Pickup_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_pickup_email = /** @type {((inputs?: Inbound_Field_Pickup_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Pickup_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_pickup_email(inputs)
});